"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classNames = require("classnames");
const react_1 = require("react");
const _1 = require("./");
class FormActions extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            debugModeEnabled: false,
        };
        this.toggleDebugMode = () => {
            this.setState({ debugModeEnabled: !this.state.debugModeEnabled });
        };
    }
    render() {
        const { loadingStateActiveOnSubmitButton, noBackButton, noJsonDebugger, noSubmitButton, objectToDebug, submitButtonDisabled, onChangeDebugObject, onClickBackButton } = this.props;
        const { debugModeEnabled } = this.state;
        return (React.createElement("div", null,
            React.createElement("div", { className: "form-group-submit" },
                !noBackButton && (React.createElement(_1.Button, { title: "Go back", className: "btn-link btn-icon", onClick: onClickBackButton },
                    React.createElement(_1.Icon, { name: "arrow_back" }))),
                !noSubmitButton && (React.createElement(_1.Button, { className: classNames({ 'btn-loading': loadingStateActiveOnSubmitButton }), color: "primary", disabled: submitButtonDisabled || loadingStateActiveOnSubmitButton, size: "lg", type: "submit" }, "Save")),
                !noJsonDebugger && (React.createElement(_1.Button, { className: "btn-icon", color: "link", onClick: this.toggleDebugMode },
                    React.createElement(_1.Icon, { name: "code" })))),
            !noJsonDebugger && debugModeEnabled && (React.createElement("div", { style: { marginTop: '1rem' } },
                React.createElement(_1.JsonDebugger, { object: objectToDebug, onChange: onChangeDebugObject })))));
    }
}
FormActions.defaultProps = {
    loadingStateActiveOnSubmitButton: false,
    noBackButton: false,
    noJsonDebugger: false,
    noSubmitButton: false,
    objectToDebug: {},
    submitButtonDisabled: false,
    onChangeDebugObject: () => { return; },
    onClickBackButton: () => { return; },
};
exports.FormActions = FormActions;



//////////////////
// WEBPACK FOOTER
// ./src/components/FormActions.tsx
// module id = 354
// module chunks = 0